import { CountrySelectField, FormSection, GridContainer, GridItem, InputFormField } from "@duosoftbg/nacid-components";
import useAppSelector from "../../../../../../../hooks/redux/base/useAppSelector";
import { countriesDataThunk } from "../../../../../../../store/redux/slice/AppData/countriesData";
import ARUniFreeSoloAutocompleteField from "../../../../../common/form/fields/ARUniFreeSoloAutocompleteField";
import { getARUniApplicantsAutocomplete } from "../../../../../../../axios/api/services";

const RequestApplicantSection = () => {
  const countriesThunkState = useAppSelector((state) => {
    return state.AppData.countries;
  });

  return (
    <FormSection label={"t.arUniEntryRequest.applicant.details"}>
      <GridContainer spacing={4} mt={0}>
        <GridItem sm={6} md={8}>
          <ARUniFreeSoloAutocompleteField
            required={true}
            labelCode={"l.arUniEntryRequest.applicant"}
            fieldName={"applicant"}
            autocompleteFn={getARUniApplicantsAutocomplete}
          />
        </GridItem>
        <GridItem sm={6} md={4}>
          <CountrySelectField
            countryField={"citizenship"}
            countryRequired={true}
            countriesThunk={countriesDataThunk}
            countriesThunkState={countriesThunkState}
            countryLabel={"l.arUniEntryRequest.citizenship"}
            onlyActive={true}
          />
        </GridItem>
        <GridItem>
          <InputFormField required={false} labelCode={"l.arUniEntryRequest.applicantEan"} fieldName={"applicantEan"} />
        </GridItem>
      </GridContainer>
    </FormSection>
  );
};
export default RequestApplicantSection;
